import PlansFeatures from './PlansFeatures';

export default PlansFeatures;
